import { supabaseClient } from '@web/utils/supabase-client';

class PawsomeLogic {
  public async updatePawsome(
    id: string,
    payload: {
      expertise: number;
      value: number;
      luxury: number;
      comfort: number;
      cleanliness: number;
    },
  ) {
    const { data, error } = await supabaseClient
      .from('business_pawsome')
      .update(payload)
      .eq('id', id);
    if (error) {
      console.error('error', error);
      throw error;
    }

    return data;
  }
}

export const pawsomeLogic = new PawsomeLogic();
